import { UseFormRegister, UseFormSetValue } from 'react-hook-form';
import React from 'react';

export type CreateInputCell = {
  fieldName: string;
  register: UseFormRegister<any>;
} & React.InputHTMLAttributes<HTMLInputElement>;

export type FormUtilities = {
  setValue: UseFormSetValue<any>;
  register: UseFormRegister<any>;
};

// ✅ NUEVO: Usar ownership y usage, remover ut (unidades)
export type dataTable = { id?: string } & {
  plate?: string;
  model?: string;
  category?: string;
  vehicleOccupantId?: string;
  ownership: 'INTERNAL' | 'EXTERNAL';
  usage: 'TRANSPORT' | 'CONSTRUCTION';
  teams?: string[];
  teamIDs?: string[];
};

export type NewVehicle = {
  plate?: string;
  model?: string;
  category?: string;
};

export type tableProps = {
  data?: any & {
    parentExpeditionOrderStatus?: string;
    state?: string;
  };
  teams?: Array<{ id: string; name: string }>;
  defaultValues?: dataTable[];
  onAdd?: (id: string) => void;
  onUpdate: (
    event: string | number,
    id: string,
    unitId: string,
    completeId: string
  ) => void;
  onDelete?: (id: string, unitId: string) => void;
} & FormUtilities;

type columnIDTypes = { [key: string]: { label: string; id: string } };

// Helper function para evitar problemas de tipos con @tanstack/react-table
export const getColumnId = (id: string): any => id;

// ✅ NUEVO: Remover 'ut' y 'usage', añadir 'category' en tabla derecha
export const columnNames: columnIDTypes = {
  plate: {
    id: 'plate',
    label: 'Matrícula',
  },
  model: {
    id: 'model',
    label: 'Model',
  },
  category: {
    id: 'category',
    label: 'Categoria',
  },
  ownership: {
    id: 'ownership',
    label: 'Propiedad',
  },
};

export type thProps = {
  variant: variantThLeft;
};

export type variantThRight = 'plate' | 'model' | 'category' | 'ownership' | 'remove';

export type variantThLeft =
  | 'plate'
  | 'model'
  | 'category'
  | 'ownership'
  | 'add';

export type thRightProps = {
  variant: variantThRight;
};

export type onChangeInputTypes = (value: string) => void;
